/** Character to show on the UI as a placeholder when a data point exists but it has no value. */ 
export const noValueSign = "-";
/** Character to show on the UI as a separator when listing multiple props inline. */ 
export const separator = "•";
